<template>
  <div class="row-table-button">
    <table class="table table-hover table-striped mt-3">
      <thead class="thead-dark text-center">
        <th class="collumn-action">{{$t('actionTableActionHeader')}}</th>
        <th class="collumn-deadline">{{$t('actionTableDeadlineHeader')}}</th>
        <th class="collumn-responsible">{{$t('actionTableResponsibleHeader')}}</th>
        <th class="collumn-status" v-if="!newOccurrence">{{$t('actionTableSituationHeader')}}</th>
        <th class="collumn-custon" v-if="editable || userEditor"></th>
      </thead>
      <tbody>
        <template>
          <tr class="text-center" v-for="action in this.actions" :key="action.id">
            <td class="collumn-action" @click="showAction(action)">{{ action.action }}</td>
            <td class="collumn-deadline" >{{ action.date | FilterDate }}</td>
            <td class="collumn-responsible" >{{ getResponsibleName(action) }}</td>
            <td class="collumn-status" v-if="!newOccurrence">
                <span>
                  <span class="mr-1 action"></span>
                  {{ action.status }}
                </span>
            </td>
            <td class="actions collumn-custon" v-if="editable || userEditor">
              <div class="buttons-actions">
                <b-icon
                  v-if="(checkUser(action) && 
                        (action.status == statusToVue.PENDING || action.status == statusToVue.LATE)) || 
                        (!newOccurrence && canShowButtons(action))"
                  class="add-action"
                  @click="askCheckAction(action)"
                  title="Concluir Ação"
                  icon="check-circle-fill"
                  aria-hidden="true"
                ></b-icon>
                <b-icon
                  v-if="canShowButtons(action)"
                  class="add-action"
                  @click="editAction(action)"
                  :title="$t('editActionButtom')"
                  icon="pencil-fill"
                  aria-hidden="true"
                ></b-icon>
                <b-icon
                  v-if="!newOccurrence && canShowButtons(action)"
                  class="add-action"
                  @click="askCancelAction(action)"
                  title="Cancelar Ação"
                  icon="trash-fill"
                  aria-hidden="true"
                ></b-icon>
                <b-icon
                  v-if="newOccurrence && canShowButtons(action)"
                  class="add-action"
                  @click.stop="askRemoveAction(action)"
                  :title="$t('deleteActionButtom')"
                  icon="trash-fill"
                  aria-hidden="true"
                ></b-icon>
              </div>
            </td>
          </tr>
        </template>
        <template>
          <tr>
            <td class="text-center td-button" colspan="5">
              <b-icon
                v-if="editable"
                class="add-action"
                @click="askAddAction"
                :title="$t('addActionButtom')"
                icon="plus-circle-fill"
                id="actionTable"
                aria-hidden="true"
              ></b-icon>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <!-- / LISTA DE AÇÕES -->

    <b-modal
      id="addingAction"
      size="md"
      hide-footer
      :title="$t('actionEditorModal')"
      :no-close-on-backdrop="true"
    >
      <FormAction
        @result="applyAction($event)"
        :responsibles="responsibleList"
        :action="action"
        :baseDate="baseDate"
      >
      </FormAction>
    </b-modal>

    <b-modal
      id="deleteAction"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
      class='msgBox'
      :question="question"
      modelname="deleteAction"
      v-bind:action="deleteAction" 
      />
    </b-modal>

    <b-modal
      id="checkAction"
      size="md"
      hide-footer
      title="Atenção"
      :no-close-on-backdrop="true"
    >
      <MessageBox
      class='msgBox'
      :question="question"
      modelname="checkAction"
      v-bind:action="checkAction" 
      />
    </b-modal>

    <b-modal
      id="cancelAction"
      size="md"
      hide-footer
      title="Atenção"
      :no-close-on-backdrop="true"
    >
      <MessageBox
      class='msgBox'
      :question="question"
      modelname="cancelAction"
      v-bind:action="cancelAction" 
      />
    </b-modal>

    <b-modal
      id="alertIvalidCancel"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        info="É necessário deixar ao menos uma ação na ocorrência."
        modelname="alertIvalidCancel"
      />
    </b-modal>

    <b-modal
      id="showAction"
      size="md"
      hide-footer
      :title="$t('modalActionDescription')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :info="descriptionAction"
        modelname="showAction"
      />
    </b-modal>
  </div>
</template>

<script>
import FormAction from "./formAction.vue";
import * as moment from "moment";
import { FiltersMixin } from "../mixins/filtersMixin";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import STATUS from "./statusEnum"
import { mapState } from "vuex";

export default {
  name:"Actiontable",

  props: [
      "responsibleList", 
      "editable", 
      "clean", 
      "actionsProp", 
      "updateActionsList", 
      "baseDate", 
      "newOccurrence", 
      "occurrenceStatus",
      "userEditor"
      ],

  components: { FormAction, MessageBox },

  mixins: [ FiltersMixin ],

  computed: mapState(["user"]),

  data: () => {
    return {
      maxTimeInDays: 0,
      actionIndex: null,
      actionId: 1,
      action: {
        id: "",
        action: "",
        date: new Date(),
        responsible: -1,
        status: STATUS.PENDING,
        closingDate: "",
      },
      actions: [],
      statusToVue: STATUS,
      transientAction: {},
      question: "",
      descriptionAction: ""
    };
  },

  watch: {
    clean() {
      this.actions = [];
    }
  },

  methods: {
    async applyAction(value) {
      if(this.actionIndex != null){
        let index = await this.actions.findIndex(x => x.id == value.id)
        this.actions[index] = value        
      }
      else{
        if(this.actions.length)
          value.id = this.actions[this.actions.length -1].id + 1;
        else
          value.id = 0

        this.actions.push(value);
      }
      this.resetFormAction()
      this.setStatus()
      this.sendActions()
      this.checkUserIsEditor()
    },

    askAddAction() {
      this.resetFormAction()
      this.$bvModal.show("addingAction")
    },

    askRemoveAction(value){
      this.question = `${this.$t('confirmRemoveActionMessage')} [${value.action}]`
      this.transientAction = value;
      this.$bvModal.show("deleteAction")
    },

    askCheckAction(value) {
      this.question = `Tem certeza que deseja Concluir a ação: [${value.action}]`
      this.transientAction = value;
      this.$bvModal.show("checkAction")
    },

    async askCancelAction(value) {
      if(!await this.checkValidCancel()){
        this.$bvModal.show("alertIvalidCancel")
        return
      }

      this.question = `Tem certeza que deseja Cancelar a ação: [${value.action}]`
      this.transientAction = value;
      this.$bvModal.show("cancelAction")
    },

    cancelAction(){
      this.transientAction.closingDate = "1900-01-01 00:00:00"
      this.transientAction.status = STATUS.CANCELED
      this.setStatus()
      this.sendActions()
      this.checkUserIsEditor()
    },

    async checkAction(){
      this.transientAction.closingDate = moment().format('YYYY-MM-DD')

      let open = moment(this.transientAction.date, "DD/MM/YYYY")._d
      let dateNow = new Date()
      dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())

      if(open.getTime() >= dateNow.getTime())
        this.transientAction.status = STATUS.COMPLETED
      else
        this.transientAction.status = STATUS.COMPLETED_LATE 

      this.setStatus()
      this.sendActions()
      this.checkUserIsEditor()
    },

    deleteAction(){
      let index = this.actions.findIndex(x => x.id == this.transientAction.id)
      this.actions.splice(index, 1);

      this.sendActions()
    },

    editAction(value) {
      this.actionIndex = this.actions.findIndex(x => x.id == value.id)
      this.action = JSON.parse(JSON.stringify(value))
      this.$bvModal.show("addingAction")
    },

    async checkValidCancel(){
      let isValid = 0;
      await this.actions.forEach(a => {
        if(a.status != STATUS.CANCELED){
          isValid++;
        }
      })

      return isValid > 1
    },

    resetFormAction() {
      this.actionIndex = null
      setTimeout(()=>{
        this.action = {
          id: "",
          action: "",
          date: this.MaskDate(new Date()),
          responsible: -1,
        };
      }, 300)
    },

    sendActions(){
      this.$emit("updateActionsList", this.actions)
    },

    getResponsibleName(action){
      if(action.responsible && action.responsible.name)
        return action.responsible.name
      else{
        let responsible = this.responsibleList.find(r => (
          r.id == action.responsableId 
          && r.unitId == action.responsableUnitId
          && r.system == action.responsableSystem))

        if(!responsible)
          return '-'

        action.responsible = responsible;

        return responsible.name
      }
    },

    async setStatus(){
      if(this.actions){
        let actionsBkp = this.actions;
        this.actions = new Array ();
        await actionsBkp.forEach(a => {
          if(!a.closingDate){
            let date = moment(a.date, "DD/MM/YYYY")._d
            let dateNow = new Date()
            dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate())
            if(date.getTime() >= dateNow.getTime())
              a.status = STATUS.PENDING
            else
              a.status = STATUS.LATE
          }
          this.actions.push(a)
        })

        this.setImgStatus()
      }
    },

    setImgStatus(){
      for(let i in this.actions){
        let action = this.actions[i]

        let element = document.querySelectorAll(`.action`)
        if(element.length)
          element[action.id].innerHTML = "";

        if(!action.status || action.status == STATUS.PENDING)
          continue;

        let img = document.createElement("img");
        img.width= 16;
        img.height= 16;
  
        if(action.status == STATUS.COMPLETED){
          img.src = require("@/assets/semaforoVerde.png");
          img.alt = "OK"
        }
  
        if(action.status == STATUS.LATE || action.status == STATUS.COMPLETED_LATE){
          img.src = require("@/assets/semaforoAmarelo.png");
          img.alt = "Atenção"
        }
  
        if(action.status == STATUS.CANCELED){
          img.src = require("@/assets/semaforoVermelho.png");
          img.alt = "Critico"
        }
        
        if(action.status && element.length){
          element[action.id].append(img)
        }
      }
    },

    canShowButtons(action){
      let statusTrue = (action.status == STATUS.PENDING || action.status == STATUS.LATE)
 
      if(statusTrue && this.editable)
        return true
      return false
    },
    
    CheckActionPending(action)
    {
      return action.status == STATUS.PENDING || action.status == STATUS.LATE
    },

    checkUser(action){
      return !this.newOccurrence && this.user.Id == action.responsableId && this.user.UnitId == action.responsableUnitId
    },

    async checkUserIsEditor (){
      if(this.occurrenceStatus == 1){
        await this.actions.forEach(a => {
          if(this.checkUser(a) && (a.status == STATUS.PENDING || a.status == STATUS.LATE))
            this.userEditor = true
        })
      }
    },

    showAction(action){
      this.descriptionAction = action.action
      this.$bvModal.show("showActionn");
    }
  },
  mounted() {
    this.actions = this.actionsProp;
    this.setStatus();
  },  
};
</script>

<style scoped>

.img-status>img{

  margin-right: 3px;
}

.row-table-button {
  display: flex;
  flex-wrap: wrap;
  min-width: 275px;
  overflow-x: auto;
  margin-bottom: 15px;
}

.text-center>td{
  text-align: center;
  flex-wrap: nowrap;
}

.add-action {
  cursor: pointer;
  outline: none;
  font-size: 23px;
  transition-duration: 200ms;
  color: #212529ce;
}

.add-action:hover {
  color: #212529;
}

.buttons-actions {
  display: flex;
  max-width: 100px;
}

.actions {
  display: flex;
  justify-content: right;
}

.actions svg {
  margin-left: 8px;
}

.collumn-action{
  max-width: 350px;
  min-width: 200px;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis; 
  cursor: pointer;
}

.collumn-status{
  max-width: 350px;
  min-width: 200px;
  align-items: baseline;
  transition-duration: 400ms;
  text-align: start !important;
}

.collumn-deadline{
  max-width: 250px;
  min-width: 110px;
}

.collumn-responsible{
  min-width: 150px;
}

.collumn-custon{
  width: 110px;
}

.buttons-actions{
  width: 100%;
}

@media only screen and (max-width: 390px) {

}




</style>
